
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from 'react';

import Layout from '@/layouts/simple';
import { GlobalEmptyComponent } from '@/components/common/GlobalComponent';
import useTranslation from 'next-translate/useTranslation';
import styles from './index.module.scss';
import { isLatinoChannel } from '@/utils/common/latino-app';

const domain = isLatinoChannel() ? 'masgusto.com' : 'sayweee.com';
const webDesc = 'MásGusto';
export default function AccessibilityStatement() {
  const { t } = useTranslation('common');

  return (
    <Layout title={t('home_social_media_influencer_policy')}>
      <div className={styles.legalContent}>
        <h3 className={styles.textUnderLine}>SOCIAL MEDIA INFLUENCER ENDORSEMENT POLICY</h3>
        <p>
          This Social Media Influencer Endorsement Policy (the "Influencer Endorsement Policy") sets forth the
          guidelines and expectations of Weee! Inc. and its affiliates (collectively, "Company", "{webDesc}", "us", or
          "our") for the services of social media or brand endorsers, promoters, or influencers ("Influencers") when
          promoting our corporate brand, products and services to their followers.
        </p>
        <p>
          <strong>Key Regulations and Guidance Governing Social Media Influencer Endorsements – An Overview</strong>
        </p>
        <div>
          <ul>
            <li>
              <strong className={styles.textUnderLine}>Section 5 of the Federal Trade Commission Act</strong> – Section
              5 of the Federal Trade Commission ("FTC") Act (the "FTC Act") protects consumers from deceptive
              advertising by prohibiting "unfair or deceptive acts or practices in or affecting commerce." An unfair
              practice is conduct which causes or has the potential to cause misinformed purchasing decisions to
              consumers. Deceptive practices are practices which involve a material representation, omission or practice
              that are likely to mislead a consumer into making a purchasing decision that they would not have made
              absent the deceptive conduct.
            </li>
            <li>
              <strong className={styles.textUnderLine}>FTC Endorsement Guides</strong> – The FTC Endorsement Guides (the
              "Endorsement Guide") embody the truth-in-advertising principle that endorsements must be honest and not
              misleading. The Endorsement Guide contains information about disclosure of "material connections" between
              advertisers and endorsers and the application of the FTC's consumer protection principles to social media
              and influencer marketing.
            </li>
          </ul>
          <p>
            The Influencer is responsible for making these disclosures and being familiar with the FTC Act, Endorsement
            Guides and complying with laws against deceptive advertising.
          </p>
          <p>
            <strong>Material Connections and Compliance with FTC Disclosure Guidelines</strong>
          </p>
          <p>
            In accordance with the FTC's disclosure guidelines, each of the Influencer's social media endorsements must
            clearly, obviously and unambiguously disclose their "material connection" with the Company's brand. A
            "material connection" is one which would impact the weight or credibility that the Influencer's audience
            gives the endorsement. "Material connections" include personal, family, or employment relationship or a
            financial relationship - such as free products and/or payment from the Company in exchange for the
            Influencer's product/service endorsement.
          </p>
          <p>
            The Company expects the Influencer to comply with the FTC Act and the FTC's social media endorsement
            guidelines and disclosure obligations throughout the course of their engagement with the Company.
          </p>
          <p>
            <strong>Guiding Principles for Effective Disclosures </strong>
          </p>
          <p>
            In accordance with the FTC's endorsement guidelines, the Influencer must ensure that their disclosure is
            clear and easy for their audience to read and understand. In addition, the Influencer must prominently
            display the disclosure with the endorsement post.
          </p>
          <p>
            The Influencer must also be mindful of the medium and social media platform that they use for the
            product/service endorsement to ensure that the disclosure is effective and compliant with the FTC
            endorsement guidelines. For photographic endorsements, the Influencer should superimpose the disclosure over
            the picture to allow the viewer sufficient time to notice and read the disclosure. For video endorsements,
            the Influencer should make the disclosure verbally and also superimpose the disclosure language in the video
            itself. For live stream endorsements, the Influencer should make the disclosure verbally and repeat the
            disclosure periodically throughout the live stream to ensure that viewers who see only part of the stream
            receive the disclosure.
          </p>
          <p>
            Regardless of the social media platform used for the brand promotion, the Influencer must use simple and
            clear language and/or hashtags that is hard for the Influencer's audience to miss. Below are a few examples
            of simple and clear disclosure language and hashtags that the Company recommends for promoting our brand,
            which are modeled after the FTC guidance:
          </p>
          <ul>
            <li>"Thank you {webDesc} for the free product."</li>
            <li>"Paid partnership with {webDesc}"</li>
            <li>"In collaboration with {webDesc}."</li>
            <li>"{webDesc} Promoter"</li>
            <li>"{webDesc} Ambassador"</li>
            <li>"{webDesc} Sponsorship"</li>
            <li>"Advertisement"</li>
            <li>"Sponsored"</li>
          </ul>
          <p>
            The FTC cautions against the use of short-form or abbreviated terms like "spon" or "collab", which could
            potentially mislead the viewer or reader. When using hashtag disclosures, the Influencer must use language
            that clearly identifies Influencer's relationship with the brand and should similarly avoid using vague or
            confusing short-form or abbreviated terms.
          </p>
          <p>
            <strong>Company Product/Service Influencer Endorsement Protocol – Guidelines for Responsible Use</strong>
          </p>
          <p>
            The Company and the Influencer both have an obligation under the FTC to protect consumers from deceptive
            advertising by prohibiting unfair or deceptive acts or practices in or affecting commerce. In addition to
            the necessary disclosures, the Influencer must ensure that their endorsement is truthful and based on their
            personal experience with the product/service they are endorsing. The Company expects the Influencer to
            honestly and transparently include their commercial relationship with the Company in all social media posts
            which promote our Company's brand, products and/or services.
          </p>
          <p>
            Influencers should keep the following protocol in mind as a guide on what they can and cannot say about the
            Company's brand, product, service they are endorsing:
          </p>
          <ul>
            <li>
              The Influencer's endorsement must reflect Influencers the honest opinion, finding, belief and experience
              with the Company's brand, product or service.
            </li>
            <li>
              The Influencer's endorsement must not make any claims that would be false, misleading or unsubstantiated
              information if the Company made them directly.
            </li>
            <li>
              The Influencer cannot discuss experience with a product/service that they have not personally tried.
            </li>
            <li>
              The Influencer is prohibited from using fake information (including, but not limited to a fake alias or
              fake post) when promoting the Company's brand, product or service.
            </li>
          </ul>
          <p>
            The Influencer must promptly correct any false, inaccurate, erroneous or otherwise misleading information in
            an endorsement post in a manner which visibly apprises the reader that the post has been altered to correct
            prior misstatements.
          </p>
          <p>
            Furthermore, the Influencer is prohibited from posting or forwarding written statements, audio, video,
            pictures or other materials that could be considered offensive, malicious, obscene, harassing or threatening
            to any readers or viewers, including, but not limited to, Company employees, customers, clients, subscribers
            or followers.
          </p>
          <p>
            The Influencer should direct any questions regarding the Company's endorsement protocol to{' '}
            {isLatinoChannel() ? `` : `the Jenny Ly at `}
            <a href={`mailto:${isLatinoChannel() ? 'pr' : 'jenny.ly'}@${domain}`}>
              {isLatinoChannel() ? 'pr' : 'jenny.ly'}@{domain}
            </a>
            .
          </p>
          <p>
            <strong>Confidentiality Obligations</strong>
          </p>
          <p>
            The Influencer acknowledges that they will receive, have access to and create documents, materials and
            information of a confidential and proprietary nature ("Confidential Information) to the Company and
            customers of the Company during the course of the Influencer's engagement with the Company. The Influencer
            acknowledges and agrees that such Confidential Information is an asset of the Company and/or its clients,
            must be kept strictly confidential and used only in connection with the performance of the Influencer's
            services. The Influencer agrees that they will not use, disclose, communicate, copy or permit the use or
            disclosure of any such Confidential Information to any third party in any manner whatsoever except to the
            existing employees of the Company or as otherwise directed or approved by the Company in the course of the
            Influencer's performance of services under their Influencer Agreement, and thereafter only with the
            Company's written permission. Upon termination of the Influencer's engagement with the Company or upon
            request of the Company, the Influencer will return to the Company all Confidential Information, including
            all copies or reproductions thereof, which are in the Influencer's possession, custody or control.
          </p>
          <p>
            <strong>Monitoring Compliance with Influencer Endorsement Policy </strong>
          </p>
          <p>
            In accordance with FTC requirements, the Company will monitor the Influencer's endorsement efforts to ensure
            that the Influencer makes appropriate disclosures of any material connection(s) with our brand and reflect
            their honest opinion, finding, belief and experience with the endorsed product/service. The Company will
            also review the Influencer's social media endorsements to ensure that they that the incorporates any
            required promotional language, hashtags or mentions related to the endorsed product/service, if any, set
            forth in the Influencer Agreement.
          </p>
          <p>
            <strong>Repercussions for Identified Influencer Endorsement Violations </strong>
          </p>
          <p>
            Should the Company identify any social media posts which violate the Influencer Endorsement Policy, the
            Company will take appropriate action against the Influencer based on the nature and extent of the identified
            violation. Repercussions for violation of the Influencer Endorsement Policy may include, but are not limited
            to a request for immediate removal of the post from all social media platforms; a post or statement to the
            Influencer's followers which corrects the identified violation; suspension of all promotional endorsements;
            training and/or re-training on compliance with the Company's Influencer Endorsement Policy and the FTC
            guidelines; and/or termination of the Influencer's contract with the Company.
          </p>
        </div>
      </div>
    </Layout>
  );
}

AccessibilityStatement.GlobalComponent = GlobalEmptyComponent;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/about/social-media-influencer-policy',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  